import { assertFields } from '~/ts-utils';
import {
  Review as ServerReview,
  ModerationStatus,
  EnrichedLiveSiteReview,
} from '@wix/ambassador-reviews-v1-enriched-live-site-review/types';

export const enrichWithModerationStatus = async (
  getReviewById: (options: { reviewId: string }) => Promise<EnrichedLiveSiteReview | undefined>,
  review: ServerReview,
): Promise<ServerReview> => {
  try {
    assertFields(review, ['id'], 'review');
    let timedOut = false;
    let moderationStatus = ModerationStatus.IN_MODERATION;
    // we hope that 3s is enough time to apply moderation rules
    setTimeout(() => {
      timedOut = true;
    }, 3000);
    for (let i = 0; i < 3; i++) {
      const throttleTimeout = new Promise((res) => setTimeout(res, 1000));
      const enrichedReview = await getReviewById({ reviewId: review.id });
      const status = enrichedReview?.review?.moderation?.moderationStatus;
      if (status && status !== ModerationStatus.SUBMITTED) {
        moderationStatus = status as unknown as ModerationStatus;
        break;
      }
      if (timedOut) {
        break;
      }
      await throttleTimeout;
    }
    return {
      ...review,
      moderation: {
        moderationStatus,
      },
    };
  } catch (e) {
    return {
      ...review,
      moderation: { moderationStatus: ModerationStatus.IN_MODERATION },
    };
  }
};
